module.exports = __webpack_public_path__ + "img/r-199.3fc161a4.jpg";